'use strict';

var SystemStatusFlightReoptDirective = function SystemStatusFlightReoptDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-flight-reopt.html'),
    controller: 'SystemStatusFlightReoptController'
  };
};
SystemStatusFlightReoptDirective.$inject = [];
module.exports = SystemStatusFlightReoptDirective;